/* MAUD DTG — two-sided cards + PDP gallery (Oct 2 2026).
   Everything keys off the alt-text convention "{Title} - {Color} - Back|Front"
   that the Liquid already parsed into data attributes. */
(function () {
  var root = document.documentElement;

  /* ---------- card mode switcher (comparison only) ---------- */
  function mode() { return root.getAttribute('data-maud-card') || 'a'; }
  function pickerWanted() {
    try { return sessionStorage.getItem('maudCardPick') === '1'; } catch (e) { return false; }
  }
  function setMode(m) {
    root.setAttribute('data-maud-card', m);
    try { sessionStorage.setItem('maudCard', m); } catch (e) {}
    document.querySelectorAll('.dtg-mode-pick button').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.m === m ? 'true' : 'false');
    });
    document.querySelectorAll('maud-dtg-card').forEach(function (c) { c.reset && c.reset(); });
  }
  function buildPicker() {
    if (!pickerWanted() || document.querySelector('.dtg-mode-pick')) return;
    if (!document.querySelector('maud-dtg-card')) return;
    var w = document.createElement('div');
    w.className = 'dtg-mode-pick';
    w.innerHTML = '<span>Card</span>' + ['a', 'b', 'c'].map(function (m) {
      return '<button type="button" data-m="' + m + '" aria-pressed="' + (m === mode() ? 'true' : 'false') + '">' + m.toUpperCase() + '</button>';
    }).join('');
    w.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) setMode(b.dataset.m);
    });
    document.body.appendChild(w);
  }

  /* ---------- shuffled rows (home "best sellers" mix): new order every visit ---------- */
  function shuffleRows() {
    document.querySelectorAll('[data-dtg-shuffle]').forEach(function (g) {
      if (g._shuf) return; g._shuf = true;
      var kids = [].slice.call(g.children);
      for (var i = kids.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = kids[i]; kids[i] = kids[j]; kids[j] = t; }
      kids.forEach(function (k) { g.appendChild(k); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shuffleRows); else shuffleRows();
  document.addEventListener('shopify:section:load', shuffleRows);

  /* ---------- colourway cycle (shared clock) ---------- */
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function xfade(img, src, srcset, done, dur) {
    var pre = new Image();
    if (srcset) { pre.sizes = img.sizes; pre.srcset = srcset; }
    pre.src = src;
    var go = function () {
      if (reduceMotion) { if (srcset) img.srcset = srcset; img.src = src; done && done(); return; }
      /* true cross-dissolve: the new colour fades in while the old one fades out (both multiply
         on white, so no dark overlap mid-fade). Opacity only — the blur that used to ride along
         was the costly part on phones (speed pass, Oct 14 2026). */
      var D = dur || 1300, EASE = 'cubic-bezier(.45,0,.2,1)';
      var clone = img.cloneNode(false);
      clone.removeAttribute('loading');
      clone.removeAttribute('data-src'); clone.removeAttribute('data-srcset');
      if (srcset) clone.srcset = srcset;
      clone.src = src;
      clone.classList.add('dtg-card__img--next');
      clone.style.opacity = '0';
      clone.style.transition = 'opacity ' + D + 'ms ' + EASE;
      img.style.transition = 'opacity ' + D + 'ms ' + EASE;
      img.after(clone);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        clone.style.opacity = '1';
        img.style.opacity = '0';
      }); });
      setTimeout(function () {
        if (srcset) img.srcset = srcset;
        img.src = src;
        var finished = false;
        var fin = function () {
          if (finished) return; finished = true;
          img.style.transition = 'none'; img.style.opacity = '';
          requestAnimationFrame(function () { clone.remove(); img.style.transition = ''; done && done(); });
        };
        (img.decode ? img.decode() : Promise.resolve()).then(fin, fin);
        setTimeout(fin, 1500);
      }, D + 50);
    };
    var fired = false;
    var once = function (ok) { if (fired) return; fired = true; ok ? go() : (done && done()); };
    pre.onload = function () { once(true); };
    pre.onerror = function () { once(false); };
    if (pre.complete && pre.naturalWidth) once(true);
    setTimeout(function () { once(!!pre.naturalWidth); }, dur ? 2500 : 4000);
  }
  var PERIOD = 30000;                                               // one colourway every 30s (T, Oct 5; was 20s)
  var Cycle = {
    cards: [], n: 0, timer: null,
    add: function (card) {
      card.last = Date.now() - PERIOD + 900 + (this.n++ % 6) * 650;    // staggered ripple
      card.vis = false;
      if ('IntersectionObserver' in window) {
        (this.io || (this.io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.target.vis = e.isIntersecting; });
        }, { rootMargin: '100px 0px' }))).observe(card);
      } else card.vis = true;
      this.cards.push(card);
      if (!this.timer) this.timer = setInterval(this.tick.bind(this), 250);
    },
    tick: function () {
      if (document.hidden) return;
      var now = Date.now();
      this.cards = this.cards.filter(function (c) { return c.isConnected; });
      this.cards.forEach(function (c) {
        if (!c.vis || c.hold || c.busy) return;
        if (now - c.last >= PERIOD) { c.last = now; c.advance(); }
      });
    }
  };

  /* ---------- two-sided product card ---------- */
  if (!customElements.get('maud-dtg-card')) {
    customElements.define('maud-dtg-card', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.initCycle();
        this.initDots();
        if (!this.classList.contains('dtg-card--pair')) return;
        var self = this;
        this.front = this.querySelector('.dtg-card__img--front');
        this.link = this.closest('a');
        this.item = this.closest('.product-item') || this;

        this.item.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.load(); });

        this.querySelectorAll('.dtg-card__toggle-btn').forEach(function (b) {
          b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.load(); self.side(b.dataset.side); });
          b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); self.load(); self.side(b.dataset.side); } });
        });

        self.addEventListener('touchstart', function () { self.load(); }, { passive: true });

        this.cur = 'back';
        /* two-sided cards show front + back together now (T, Oct 14 2026), so the front loads as the card nears the screen */
        this.watchLoad();
      }
      /* colourway cycle: every 5s the card crossfades to the next colourway (back for
         two-sided cards, front for front-only), and the card + title link follow it so a
         click lands on the colour on screen. Pauses on hover and while off-screen. */
      initCycle() {
        var raw = this.getAttribute('data-colors');
        if (!raw) return;
        try { this.colors = JSON.parse(raw); } catch (e) { return; }
        if (!this.colors || this.colors.length < 2) return;
        var self = this;
        this.ci = 0;
        this.item = this.closest('.product-item') || this;
        this.item.addEventListener('mouseenter', function () { self.hold = true; });
        this.item.addEventListener('mouseleave', function () { self.hold = false; self.last = Date.now(); });
        Cycle.add(this);
      }
      advance() {
        if (this.busy) return;
        var n = this.colors.length, c = this.colors[(this.ci + 1) % n], self = this;
        var pair = this.classList.contains('dtg-card--pair');
        var main = this.querySelector('.dtg-card__img--main');
        var front = this.querySelector('.dtg-card__img--front');
        var mSrc = pair ? (c.b || c.f) : (c.f || c.b), mSet = pair ? (c.bs || c.fs) : (c.fs || c.bs);
        if (!main || !mSrc) { this.ci = (this.ci + 1) % n; return; }
        this.busy = true;
        xfade(main, mSrc, mSet, function () {
          self.ci = (self.ci + 1) % n;
          self.busy = false;
          var links = [];
          var a = self.closest('a'); if (a) links.push(a);
          if (self.item) self.item.querySelectorAll('a.product-item-meta__title').forEach(function (l) { links.push(l); });
          links.forEach(function (l) { if (c.u) l.href = c.u; });
        });
        if (pair && front && c.f) {
          if (front.dataset.src) { front.dataset.src = c.f; front.dataset.srcset = c.fs || ''; }
          else xfade(front, c.f, c.fs);
        }
      }
      /* colour dots (T, Oct 14 2026): one dot per colourway (first 3). Tap a dot, or swipe the
         card, to show that colour's back + front; the card + title links follow it. */
      initDots() {
        var raw = this.getAttribute('data-cw'), list;
        if (!raw) return;
        try { list = JSON.parse(raw); } catch (e) { return; }
        if (!list || list.length < 2) return;
        var self = this, F = '//' + location.host + '/cdn/shop/files/';
        function u(f, w) { return F + f + (f.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
        function ss(f) { return [300, 450, 600, 800].map(function (w) { return u(f, w) + ' ' + w + 'w'; }).join(', '); }
        this.cw = list.map(function (c) {
          var o = { u: c.u, n: c.c };
          if (c.b) { o.b = u(c.b, 600); o.bs = ss(c.b); }
          if (c.f) { o.f = u(c.f, 600); o.fs = ss(c.f); }
          return o;
        });
        this.cwi = 0;
        var old = this.querySelector('.dtg-card__dots'); if (old) old.remove();
        var bar = document.createElement('span');
        bar.className = 'dtg-card__dots dtg-card__dots--cw';
        bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', 'Colours');
        this.cw.forEach(function (c, i) {
          var d = document.createElement('i');
          d.setAttribute('role', 'button'); d.tabIndex = 0;
          d.setAttribute('aria-label', c.n || ('Colour ' + (i + 1)));
          if (!i) d.className = 'is-on';
          function pick(e) { e.preventDefault(); e.stopPropagation(); self.goColor(i); }
          d.addEventListener('click', pick);
          d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') pick(e); });
          bar.appendChild(d);
        });
        bar.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
        this.appendChild(bar);
        this.dots = bar.children;
        /* swipe: left = next colour, right = previous */
        var x0 = 0, y0 = 0, t0 = 0;
        this.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); }, { passive: true });
        this.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0, n = self.cw.length;
          if (Math.abs(dx) > 28 && Math.abs(dx) > Math.abs(dy) * 1.3 && Date.now() - t0 < 800) {
            self.goColor((self.cwi + (dx < 0 ? 1 : n - 1)) % n);
            self._swiped = Date.now();
          }
        }, { passive: true });
        var a = this.closest('a');
        if (a) a.addEventListener('click', function (e) {
          if (self._swiped && Date.now() - self._swiped < 500) { e.preventDefault(); e.stopPropagation(); }
        }, true);
      }
      goColor(i) {
        if (!this.cw || i === this.cwi) return;
        if (this.cwBusy) { this.cwNext = i; return; }
        var c = this.cw[i], self = this;
        var pair = this.classList.contains('dtg-card--pair');
        var main = this.querySelector('.dtg-card__img--main');
        var front = this.querySelector('.dtg-card__img--front');
        var mSrc = pair ? (c.b || c.f) : (c.f || c.b), mSet = pair ? (c.bs || c.fs) : (c.fs || c.bs);
        this.cwi = i;
        Array.prototype.forEach.call(this.dots, function (d, k) { d.classList.toggle('is-on', k === i); });
        var links = [], a = this.closest('a');
        if (a) links.push(a);
        var item = this.closest('.product-item');
        if (item) item.querySelectorAll('a.product-item-meta__title').forEach(function (l) { links.push(l); });
        links.forEach(function (l) { if (c.u) l.href = c.u; });
        if (!main || !mSrc) return;
        this.cwBusy = true;
        xfade(main, mSrc, mSet, function () {
          self.cwBusy = false;
          if (self.cwNext != null) { var n = self.cwNext; self.cwNext = null; self.goColor(n); }
        }, 420);
        if (pair && front && c.f) {
          if (front.dataset.src) { front.dataset.src = c.f; front.dataset.srcset = c.fs || ''; this.load(); }
          else xfade(front, c.f, c.fs, null, 420);
        }
      }
      watchLoad() {
        var self = this;
        if (!('IntersectionObserver' in window)) { this.load(); return; }
        var io = new IntersectionObserver(function (es) {
          if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); self.load(); }
        }, { rootMargin: '200px 0px' });
        io.observe(this);
      }
      load() {
        var f = this.front;
        if (!f || !f.dataset.src) return;
        if (f.dataset.srcset) f.srcset = f.dataset.srcset;
        f.src = f.dataset.src;
        delete f.dataset.src; delete f.dataset.srcset;
      }
      side(s) {
        this.cur = s;
        this.classList.toggle('is-front', s === 'front');
        this.querySelectorAll('.dtg-card__toggle-btn').forEach(function (b) {
          var on = b.dataset.side === s;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      reset() {
        if (!this.classList.contains('dtg-card--pair')) return;
        this.side('back');
        if (mode() !== 'a') this.load();
      }
    });
  }

  /* ---------- PDP: colour-filtered Back/Front gallery ---------- */
  function initPdp(pm) {
    if (pm._dtg) return;
    pm._dtg = true;
    var pos = parseInt(pm.getAttribute('data-dtg-color-pos'), 10) || 0;
    var cur = pm.getAttribute('data-dtg-color') || '';
    var carousel = pm.querySelector('flickity-carousel');
    var ctrl = pm.querySelector('.dtg-sides');
    var split = pm.querySelector('[data-dtg-split]');
    var side = 'back';
    var keepView = false;   /* set by a swipe: colour change keeps the current view instead of jumping to both sides */
    /* colour thumbnails (maud-swatches.js) also keep the view — only the arrows open the front/back pair (T, Oct 6) */
    pm.addEventListener('dtg:keepview', function () { keepView = true; });

    /* split view: clone the current colour's back + front into the panel */
    function showSplit() {
      if (!split) return;
      ['back', 'front'].forEach(function (s) {
        var item = pm.querySelector('.product__media-item:not(.is-filtered)[data-dtg-side="' + s + '"]');
        var slot = split.querySelector('.dtg-split__half[data-side="' + s + '"] .dtg-split__img');
        var src = item && item.querySelector('img');
        if (!slot) return;
        var key = src ? (src.getAttribute('src') || '') : '';
        if (slot.getAttribute('data-k') === key && slot.firstChild) return;   /* same colour: keep the decoded clone, no flash */
        slot.setAttribute('data-k', key);
        slot.innerHTML = '';
        if (src) {
          var img = src.cloneNode(true);
          img.removeAttribute('loading');
          img.removeAttribute('reveal');
          img.sizes = '(max-width: 999px) 72vw, 480px';
          img.style.opacity = '';
          slot.appendChild(img);
        }
      });
      clearTimeout(leaveT);
      pm.classList.remove('is-leaving');
      pm.classList.add('is-split');
      split.setAttribute('aria-hidden', 'false');
      paint('both');
    }
    /* the pair fades out over the single side instead of vanishing (the slide underneath settles while it fades) */
    var leaveT = 0;
    function hideSplit() {
      if (!split || !pm.classList.contains('is-split')) return;
      split.setAttribute('aria-hidden', 'true');
      pm.classList.add('is-leaving');
      clearTimeout(leaveT);
      leaveT = setTimeout(function () { pm.classList.remove('is-split', 'is-leaving'); paint(); }, 260);
    }
    /* taps that land mid-transition (double taps) are swallowed so changes never stack */
    var lockUntil = 0;
    function locked() { var n = Date.now(); if (n < lockUntil) return true; lockUntil = n + 380; return false; }
    if (split) {
      split.addEventListener('click', function (e) {
        var h = e.target.closest('.dtg-split__half');
        if (!h || locked()) return;
        hideSplit();
        var t = target(h.dataset.side);
        if (t && carousel && carousel.select) carousel.select('[data-media-id="' + t.getAttribute('data-media-id') + '"]');
        paint(h.dataset.side);
      });
    }

    function selectedItem() { return pm.querySelector('.product__media-item.is-selected'); }
    function paint(force) {
      var s = selectedItem();
      if (force === 'both') { /* keep `side` as the last single side */ }
      else if (force) side = force;
      else if (s && s.getAttribute('data-dtg-side')) side = s.getAttribute('data-dtg-side');
      if (!ctrl) return;
      var shown = pm.classList.contains('is-split') && !pm.classList.contains('is-leaving') ? '' : side; /* split = neither side picked yet */
      ctrl.classList.toggle('is-single', !!split && shown !== '');
      ctrl.querySelectorAll('.dtg-sides__btn').forEach(function (b) {
        var on = b.dataset.side === shown;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function target(s) {
      var q = '.product__media-item:not(.is-filtered)[data-dtg-side="' + s + '"]';
      return pm.querySelector(q);
    }

    if (ctrl) {
      ctrl.addEventListener('click', function (e) {
        var b = e.target.closest('.dtg-sides__btn');
        if (!b || locked()) return;
        /* tapping the side that's already showing goes back to both sides */
        var single = split && (!pm.classList.contains('is-split') || pm.classList.contains('is-leaving'));
        if (b.dataset.side === 'both' || (single && b.dataset.side === side)) { showSplit(); return; }
        hideSplit();
        var t = target(b.dataset.side);
        if (t && carousel && carousel.select) carousel.select('[data-media-id="' + t.getAttribute('data-media-id') + '"]');
        paint(b.dataset.side);
      });
    }

    var raf = 0;
    new MutationObserver(function () {
      clearTimeout(raf);
      raf = setTimeout(function () { paint(); }, 40);
    }).observe(pm, { subtree: true, attributes: true, attributeFilter: ['class'] });

    var form = document.getElementById(pm.getAttribute('form-id'));
    if (!form || !pos) { if (split) showSplit(); else paint(); return; }
    form.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.options) return;
      var color = v.options[pos - 1];
      if (!color || color === cur) return;
      cur = color;
      pm.setAttribute('data-dtg-color', color);
      /* hold the gallery's height through the swap so the page under it never jumps */
      var h = pm.offsetHeight;
      if (h) pm.style.minHeight = h + 'px';
      setTimeout(function () {
        applyColor(color);
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          setTimeout(function () { pm.style.minHeight = ''; }, 250);
        }); });
      }, 0);
    });
    /* once the page is idle, warm every colour's photos so a swap never waits on the network */
    function warm() {
      pm.querySelectorAll('.product__media-item img').forEach(function (im) {
        if (im.loading === 'lazy') im.loading = 'eager';
        if (im.decode) im.decode().catch(function () {});
      });
    }
    if (document.readyState === 'complete') setTimeout(warm, 1200); else addEventListener('load', function () { setTimeout(warm, 1200); });

    function applyColor(color) {
      var keep = side;
      pm.querySelectorAll('[data-dtg-color]').forEach(function (el) {
        var c = el.getAttribute('data-dtg-color');
        el.classList.toggle('is-filtered', !!c && c !== color);
      });
      var t = pm.querySelector('.product__media-item[data-dtg-color="' + cssEsc(color) + '"][data-dtg-side="' + keep + '"]') ||
              pm.querySelector('.product__media-item[data-dtg-color="' + cssEsc(color) + '"]');
      if (!t) return;
      var id = t.getAttribute('data-media-id');
      pm.querySelectorAll('[data-media-id]').forEach(function (el) {
        var on = el.getAttribute('data-media-id') === id;
        el.classList.toggle('is-selected', on && el.classList.contains('product__media-item'));
        el.classList.toggle('is-initial-selected', on && el.classList.contains('product__media-item'));
      });
      var img = t.querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
      if (carousel && carousel.reload) carousel.reload();
      var wasSplit = pm.classList.contains('is-split') && !pm.classList.contains('is-leaving');
      paint(keep);
      if (!keepView || wasSplit) showSplit();
      keepView = false;
    }
    /* swipe the tee to change colourway (T, Oct 3): the garment follows the finger, the next
       colour slides in from the side it was pushed toward; the view (both sides / one side) is kept */
    var wrap = pm.querySelector('.product__media-list-wrapper');
    function swatches() {
      if (!form) return [];
      /* the swatch radios live outside the <form> (form="…" attribute), so match on that */
      var l = document.querySelectorAll('.variant-swatch-list input[type="radio"][form="' + cssEsc(form.getAttribute('id')) + '"]');
      if (!l.length) l = form.querySelectorAll('.variant-swatch-list input[type="radio"]');
      return Array.prototype.slice.call(l);
    }
    function go(dir) {
      var list = swatches(); if (list.length < 2) return false;
      var i = list.findIndex(function (x) { return x.checked; }); if (i < 0) i = 0;
      keepView = true;
      list[(i + dir + list.length) % list.length].click();
      return true;
    }
    if (wrap && form && pos) {
      var sx = 0, sy = 0, dx = 0, drag = 0, swipedAt = 0;      /* drag: 0 undecided, 1 horizontal, -1 vertical */
      var set = function (x, o, t) { wrap.style.transition = t || 'none'; wrap.style.transform = x ? 'translateX(' + x + 'px)' : ''; wrap.style.opacity = o == null ? '' : o; };
      wrap.addEventListener('touchstart', function (e) {
        if (e.touches.length > 1) { drag = -1; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; drag = 0;
      }, { passive: true });
      wrap.addEventListener('touchmove', function (e) {
        if (drag === -1 || e.touches.length > 1) return;
        var x = e.touches[0].clientX - sx, y = e.touches[0].clientY - sy;
        if (!drag) { if (Math.abs(x) < 8 && Math.abs(y) < 8) return; drag = Math.abs(x) > Math.abs(y) * 1.2 ? 1 : -1; if (drag < 0) return; }
        e.preventDefault(); dx = x;
        set(x * .45, Math.max(.35, 1 - Math.abs(x) / 520));
      }, { passive: false });
      var end = function () {
        if (drag !== 1) { drag = 0; return; }
        drag = 0;
        if (Math.abs(dx) > 45 && go(dx < 0 ? 1 : -1)) {
          swipedAt = Date.now();
          var from = dx < 0 ? 46 : -46;                          /* new colour enters from the side it was pushed away from */
          set(from, 0);
          requestAnimationFrame(function () { requestAnimationFrame(function () {
            set(0, 1, 'transform .32s cubic-bezier(.2,.8,.2,1), opacity .22s ease');
            setTimeout(function () { set(0, null); }, 340);
          }); });
        } else {
          set(0, 1, 'transform .25s cubic-bezier(.2,.8,.2,1), opacity .2s ease');
          setTimeout(function () { set(0, null); }, 260);
        }
      };
      wrap.addEventListener('touchend', end, { passive: true });
      wrap.addEventListener('touchcancel', end, { passive: true });
      /* a swipe is not a tap on the split halves / zoom */
      wrap.addEventListener('click', function (e) { if (Date.now() - swipedAt < 450) { e.preventDefault(); e.stopPropagation(); } }, true);
      wrap.style.touchAction = 'pan-y pinch-zoom';
    }
    /* colour stepper under the tee (replaces the colour swatches): ‹ BLACK › */
    if (wrap && form && pos && swatches().length > 1) {
      var nav = document.createElement('div');
      nav.className = 'dtg-colornav';
      nav.setAttribute('role', 'group'); nav.setAttribute('aria-label', 'Colour');
      nav.innerHTML = '<button type="button" class="dtg-colornav__arrow" data-dir="-1" aria-label="Previous colour">&lsaquo;</button>' +
        '<span class="dtg-colornav__name" aria-live="polite"></span>' +
        '<button type="button" class="dtg-colornav__arrow" data-dir="1" aria-label="Next colour">&rsaquo;</button>';
      var name = nav.querySelector('.dtg-colornav__name');
      var label = function () {
        var on = swatches().filter(function (x) { return x.checked; })[0];
        name.textContent = on ? on.value : '';
      };
      label();
      (ctrl || wrap).parentNode.insertBefore(nav, ctrl || wrap.nextSibling);
      nav.addEventListener('click', function (e) {
        var a = e.target.closest('.dtg-colornav__arrow'); if (!a) return;
        var d = +a.getAttribute('data-dir');
        /* let the tap paint first, then swap the colour right after (speed pass, Oct 14 2026):
           the swap runs the theme's variant change, which shouldn't hold up the press itself */
        setTimeout(function () { step(d); }, 0);
      });
      var step = function (d) {
        if (!go(d)) return;
        keepView = false;   /* arrows (and colour thumbnails) open the new colour on both sides, Front/Back un-pressed (T, Oct 6) */
        var from = d > 0 ? 46 : -46;
        wrap.style.transition = 'none'; wrap.style.transform = 'translateX(' + from + 'px)'; wrap.style.opacity = '0';
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          wrap.style.transition = 'transform .32s cubic-bezier(.2,.8,.2,1), opacity .22s ease';
          wrap.style.transform = ''; wrap.style.opacity = '1';
          setTimeout(function () { wrap.style.transition = ''; wrap.style.opacity = ''; }, 340);
        }); });
      };
      form.addEventListener('variant:changed', function () { setTimeout(label, 0); });
      document.documentElement.classList.add('dtg-has-colornav');
    }
    if (split) showSplit(); else paint();
  }

  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }

  /* ---------- Shop-by-Design tiles: shuffle through the design's pieces ----------
     Every tile crossfades to another garment of its design on the shared 30s clock,
     random order but never the same garment type twice in a row (so it doesn't
     sit on tees). Pauses on hover so the Front swap still works. */
  /* compact shuffle entries ({t, b, f} = file names after /cdn/shop/files/) → full URLs + srcsets */
  var FILES = '//' + location.host + '/cdn/shop/files/';
  function expandMini(it) {
    if (!it || it.bs || !it.b || it.b.indexOf('/') > -1) return it;
    function u(f, w) { return FILES + f + (f.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function ss(f) { return [200, 300, 400, 600].map(function (w) { return u(f, w) + ' ' + w + 'w'; }).join(', '); }
    var o = { t: it.t, b: u(it.b, 400), bs: ss(it.b) };
    if (it.f) { o.f = u(it.f, 400); o.fs = ss(it.f); }
    return o;
  }
  function initDesign(el) {
    if (el._dsh) return; el._dsh = 1;
    var list; try { list = JSON.parse(el.getAttribute('data-shuffle')); } catch (e) { return; }
    list = (list || []).filter(Boolean).map(expandMini);
    var main = el.querySelector('.dtg-design__img--back');
    if (!main || list.length < 2) return;
    var first = list.shift();
    for (var i = list.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = list[i]; list[i] = list[j]; list[j] = t; }
    var seq = [first], prev = first.t;
    while (list.length) {
      var k = 0;
      while (k < list.length && list[k].t === prev) k++;
      if (k === list.length) k = 0;
      var it = list.splice(k, 1)[0]; seq.push(it); prev = it.t;
    }
    var at = 0;
    el.addEventListener('mouseenter', function () { el.hold = true; });
    el.addEventListener('mouseleave', function () { el.hold = false; });
    el.advance = function () {
      at = (at + 1) % seq.length;
      var it = seq[at], fr = el.querySelector('.dtg-design__img--front');
      el.busy = true;
      xfade(main, it.b, it.bs, function () { el.busy = false; });
      if (fr) {
        fr.removeAttribute('data-src'); fr.removeAttribute('data-srcset');
        fr.srcset = it.fs || it.bs; fr.src = it.f || it.b;
      }
    };
    Cycle.add(el);
  }

  /* cards only float / sway while they're on screen (speed pass, Oct 14 2026): a collection page
     had ~170 animations running at once, most of them far off screen */
  var offIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('dtg-off', !e.isIntersecting); });
  }, { rootMargin: '150px 0px' }) : null;
  function watchCards() {
    if (!offIO) return;
    document.querySelectorAll('.product-item--dtg:not([data-dtg-io])').forEach(function (c) {
      c.setAttribute('data-dtg-io', '');
      c.classList.add('dtg-off');
      offIO.observe(c);
    });
  }

  function boot() {
    document.querySelectorAll('.dtg-design[data-shuffle]').forEach(initDesign);
    document.querySelectorAll('product-media[data-dtg]').forEach(initPdp);
    buildPicker();
    watchCards();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* sections loaded later (quick view, recommendations) */
  var moT = 0;
  new MutationObserver(function () {
    if (moT) return;
    moT = setTimeout(function () {                       /* batch DOM bursts into one pass */
      moT = 0;
      document.querySelectorAll('product-media[data-dtg]').forEach(initPdp);
      document.querySelectorAll('.dtg-design[data-shuffle]').forEach(initDesign);
      watchCards();
    }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Tile / design-chip fronts load on first hover (desktop only; touch shows the back). */
(function () {
  function wake(scope) {
    scope.querySelectorAll('img[data-dtg-lazy][data-src]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.src; delete img.dataset.srcset;
    });
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var t = e.target.closest && e.target.closest('.dtg-tile, .dtg-design');
    if (t) wake(t);
  });
})();

/* "CUSTOMIZER" nav/pill links (href ends #customizer) open the waitlist
   pop-up from the mock wall that sits in the footer of every page. */
(function () {
  function closeDrawers() {
    var closed = false;
    document.querySelectorAll('drawer-content[open], .drawer[open]').forEach(function (d) {
      closed = true;
      try { d.open = false; } catch (e) {}
      d.removeAttribute('open');
    });
    return closed;
  }
  function goCustomizer() {
    var b = document.querySelector('[data-mw-open]');
    var wall = document.querySelector('[data-mock-wall]');
    if (!b || !wall) return false;
    /* a menu drawer releases its scroll lock on close, so scroll after it has */
    if (closeDrawers()) { setTimeout(run, 450); } else { run(); }
    return true;
    function run() {
    wall.scrollIntoView({ block: 'start', behavior: 'instant' });
    var t0 = Date.now();
    (function wait() {
      if (b.classList.contains('is-placed') || Date.now() - t0 > 6000) {
        b.scrollIntoView({ block: 'center', behavior: 'instant' });
        setTimeout(function () { b.click(); }, 380);
      } else {
        setTimeout(wait, 120);
      }
    })();
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#customizer"]');
    if (!a) return;
    if (goCustomizer()) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  function fromHash() { if (location.hash === '#customizer') setTimeout(goCustomizer, 300); }
  window.addEventListener('hashchange', fromHash);
  if (document.readyState === 'complete') fromHash(); else window.addEventListener('load', fromHash);
})();


/* Units sold counter: formats with commas and counts up the first time it scrolls into view */
(function () {
  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
  function run(el) {
    if (el._dc) return; el._dc = 1;
    var num = el.querySelector('.dtg-count__num'), to = +el.getAttribute('data-dtg-count') || 0;
    num.textContent = fmt(to);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    var from = Math.floor(to * .82), D = 1800;
    num.textContent = fmt(from);
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; io.disconnect();
      var t0 = performance.now();
      (function step(t) {
        var p = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - p, 4);
        num.textContent = fmt(from + (to - from) * e);
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    }, { threshold: .6 });
    io.observe(el);
  }
  function boot() { document.querySelectorAll('[data-dtg-count]').forEach(run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Product details / size chart pop-ups: grow out of their box, shrink back into it
   (same motion as the footer mock wall's zoom). */
(function () {
  var cur = null, veil = null, timer = null;
  function box(p) {
    var vw = innerWidth, vh = innerHeight, W = p.offsetWidth, H = p.offsetHeight;
    var L = Math.round((vw - W) / 2), T = Math.max(12, Math.round((vh - H) / 2));
    p.style.left = L + 'px'; p.style.top = T + 'px';
    return { L: L, T: T, W: W, H: H };
  }
  function from(r, b) { return 'translate(' + (r.left - b.L) + 'px,' + (r.top - b.T) + 'px) scale(' + (r.width / b.W) + ',' + (r.height / b.H) + ')'; }
  /* shared page lock (also used by the mock wall): body pinned so nothing behind a pop-up can scroll, iOS included */
  var L = window.__maudLock = window.__maudLock || { n: 0, y: 0,
    on: function () {
      if (this.n++) return;
      this.y = window.scrollY;
      var b = document.body.style;
      b.position = 'fixed'; b.top = -this.y + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
      document.documentElement.classList.add('dtg-pop-locked');
    },
    off: function () {
      if (!this.n || --this.n) return;
      var b = document.body.style;
      b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
      var h = document.documentElement, sb = h.style.scrollBehavior;
      h.style.scrollBehavior = 'auto';                                  // no smooth-scroll ride back from the top
      h.classList.remove('dtg-pop-locked');
      try { window.scrollTo({ top: this.y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, this.y); }
      h.style.scrollBehavior = sb;
    } };
  var held = false;
  function open(btn) {
    var p = document.getElementById(btn.getAttribute('data-dtg-pop-open'));
    if (!p || cur) return;
    if (!held) { L.on(); held = true; }
    clearTimeout(timer);
    if (p.parentNode !== document.body) document.body.appendChild(p);
    p.hidden = false; p.classList.remove('is-closing'); p.classList.add('is-shut');
    var b = box(p);
    if (!veil) { veil = document.createElement('div'); veil.className = 'dtg-pop-veil'; veil.addEventListener('click', close); }
    document.body.insertBefore(veil, p);
    p.style.transition = 'none';
    p.style.transform = from(btn.getBoundingClientRect(), b);
    btn.classList.add('is-source');
    cur = { p: p, btn: btn, b: b };
    void p.offsetWidth;
    requestAnimationFrame(function () {
      p.style.transition = ''; p.style.transform = 'none';
      p.classList.remove('is-shut'); veil.classList.add('is-open');
    });
  }
  function close() {
    if (!cur) return;
    var o = cur; cur = null;
    o.p.classList.add('is-shut', 'is-closing');
    o.btn.classList.remove('is-source');                 // box lands on a visible button and fades into it
    o.p.scrollTop = 0;
    o.p.style.transform = from(o.btn.getBoundingClientRect(), o.b);
    veil.classList.remove('is-open');
    var done = false;
    function fin() {
      if (done) return; done = true;
      o.p.hidden = true; o.p.style.transform = ''; o.p.classList.remove('is-closing');
      if (veil.parentNode && !cur) veil.parentNode.removeChild(veil);
      if (!cur && held) { held = false; L.off(); }
    }
    o.p.addEventListener('transitionend', function te(e) { if (e.target === o.p && e.propertyName === 'transform') { o.p.removeEventListener('transitionend', te); fin(); } });
    timer = setTimeout(fin, 500);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dtg-pop-open]');
    if (b) { e.preventDefault(); open(b); return; }
    if (e.target.closest && e.target.closest('[data-dtg-pop-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  addEventListener('resize', function () { if (cur) { cur.p.style.transition = 'none'; cur.b = box(cur.p); void cur.p.offsetWidth; cur.p.style.transition = ''; } });
})();

/* Colour swatches on DTG product pages show the front of each colourway */
(function () {
  function run() {
    var tag = document.querySelector('[data-dtg-swatch-fronts]');
    if (!tag) return;
    var map; try { map = JSON.parse(tag.textContent); } catch (e) { return; }
    document.querySelectorAll('.variant-swatch').forEach(function (sw) {
      var inp = sw.querySelector('input'), img = sw.querySelector('.variant-swatch__image');
      if (!inp || !img || !map[inp.value]) return;
      var f = map[inp.value];
      img.removeAttribute('loading');
      img.srcset = f.ss; img.src = f.s;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

/* Welcome hello (simple version, Oct 14 2026) — the first time someone lands in a visit.
   WELCOME / TO / MAUD (stacked on phones, one line on wider screens) rises in softly letter by letter (sized to fit the
   screen with room to spare), the product cards on screen do their short hop, then
   it fades. Click-through, about a second, any tap/scroll/key sends it off early.
   ?hi=1 forces it. */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* with the beams on, the hello is done by the lights (maud-bg.js); ?hi=text forces this one */
  if (document.documentElement.getAttribute('data-maud-bg') === 'beams' && !/[?&]hi=text/.test(location.search)) return;
  var force = /[?&]hi=[a-z0-9]+/.test(location.search);
  try { if (!force && sessionStorage.getItem('maudHi')) return; sessionStorage.setItem('maudHi', '1'); } catch (e) {}

  var LINES = ['Welcome', 'to', 'Maud'];
  var RED = '#d60000';
  var CSS =
  '.mhi{position:fixed;inset:0;z-index:2147483000;pointer-events:none;display:flex;align-items:center;justify-content:center;overflow:hidden}' +
  '.mhi__veil{position:absolute;inset:0;background:#fff;opacity:0;animation:mhi-veil .2s ease-out forwards}' +
  '@keyframes mhi-veil{to{opacity:.72}}' +
  '.mhi.is-out .mhi__veil{opacity:.72;animation:mhi-veilout .3s ease-in forwards}@keyframes mhi-veilout{to{opacity:0}}' +
  '.mhi__stage{position:relative;display:flex;flex-direction:column;align-items:center}' +
  '.mhi.is-out .mhi__stage{animation:mhi-lift .28s ease-in forwards}@keyframes mhi-lift{to{opacity:0;transform:translateY(-10px)}}' +
  '.mhi__word{position:relative;display:flex;width:max-content;margin:0;padding:0;font-family:var(--heading-font-family,inherit);font-size:clamp(34px,10vw,76px);line-height:.92;font-weight:900;letter-spacing:-.055em;text-transform:uppercase;color:#0a0a0a;white-space:nowrap;text-shadow:0 0 8px rgba(214,0,0,.22)}' +
  '.mhi__word--red{color:' + RED + ';text-shadow:0 0 8px rgba(214,0,0,.3)}' +
  '.mhi__word span{display:inline-block;opacity:0;transform:translateY(18%);animation:mhi-rise .38s cubic-bezier(.2,.7,.3,1) calc(40ms + var(--i) * 18ms) forwards}' +
  '@keyframes mhi-rise{to{opacity:1;transform:none}}' +
  /* phones: stacked, one word per line; wider screens: one line */
  '@media (min-width:768px){.mhi__stage{flex-direction:row;align-items:baseline;gap:.26em;font-size:clamp(34px,10vw,76px)}}';

  function go() {
    if (!document.getElementById('mhi-css')) {
      var st = document.createElement('style'); st.id = 'mhi-css'; st.textContent = CSS; document.head.appendChild(st);
    }
    var el = document.createElement('div');
    el.className = 'mhi';
    el.setAttribute('aria-hidden', 'true');
    var h = '<div class="mhi__veil"></div><div class="mhi__stage">', n = 0;
    LINES.forEach(function (line, li) {
      h += '<p class="mhi__word' + (li === LINES.length - 1 ? ' mhi__word--red' : '') + '">';
      line.split('').forEach(function (ch) { h += '<span style="--i:' + (n++) + '">' + ch + '</span>'; });
      h += '</p>';
    });
    el.innerHTML = h + '</div>';
    document.body.appendChild(el);

    /* the longest line sets the size; keep a wide margin either side so nothing touches the edge */
    var words = el.querySelectorAll('.mhi__word');
    var maxW = Math.min(document.documentElement.clientWidth || innerWidth, innerWidth) - 56; if (maxW > 1200) maxW = 1200;
    var stage = el.querySelector('.mhi__stage'), oneLine = getComputedStyle(stage).flexDirection === 'row';
    var widest = 0; words.forEach(function (w) { widest = Math.max(widest, w.offsetWidth); });
    if (oneLine) widest = stage.offsetWidth;
    if (widest > maxW) {
      var fs = parseFloat(getComputedStyle(words[0]).fontSize) * maxW / widest * .97;
      words.forEach(function (w) { w.style.fontSize = fs + 'px'; });
    }

    var landed = 40 + n * 18 + 380;
    /* the pieces on screen do their short hop */
    var vh = innerHeight;
    document.querySelectorAll('.product-item--dtg .product-item__image-wrapper, .dtg-design__img').forEach(function (c) {
      var r = c.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      c.style.animationDelay = (landed - 250 + (r.left / innerWidth) * 250 + (r.top / vh) * 150) + 'ms';
      c.classList.add('dtg-hi-hop');
      setTimeout(function () { c.classList.remove('dtg-hi-hop'); c.style.animationDelay = ''; }, landed + 2200);
    });

    var gone = false;
    function out() {
      if (gone) return; gone = true;
      el.classList.add('is-out');
      setTimeout(function () { el.remove(); }, 380);
      ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach(function (ev) { removeEventListener(ev, out); });
    }
    setTimeout(out, landed + 380);
    setTimeout(function () { ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach(function (ev) { addEventListener(ev, out, { passive: true }); }); }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* One shared /cart.js request (speed pass, Oct 14 2026). Every cart change used to fire ~8
   separate /cart.js requests at once (cart badge, header count, …), which queued up
   and made each one slower. Callers that ask while a request is already on its way now share it. */
window.__maudCart = window.__maudCart || (function () {
  var p = null;
  return function () {
    if (p) return p;
    p = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    p.then(function () { p = null; }, function () { p = null; });
    return p;
  };
})();

/* Shipping note above checkout in the cart drawer and on the cart page:
   "Printed to order · Allow 3–5 business days to ship".
   Priority fulfillment was removed from MAUD (T, Oct 16 2026): no toggle any more, and any old
   priority line still sitting in a shopper's cart is taken out. */
(function () {
  var HANDLE = 'priority-fulfillment';
  var NOTE = '<p class="dtg-prio__note"><span>Printed to order</span><span>Allow 3–5 business days to ship</span></p>';
  function refresh() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
  /* remove any leftover priority lines; resolves true if the cart was changed */
  function strip() {
    return window.__maudCart().then(function (c) {
      var u = {}, n = 0;
      c.items.forEach(function (it) { if (it.handle === HANDLE) { u[it.key] = 0; n++; } });
      if (!n) return false;
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) }).then(function () { return true; });
    });
  }
  function note(foot) {
    if (!foot || foot.querySelector('.dtg-prio')) return;
    var b = document.createElement('div');
    b.className = 'dtg-prio';
    b.innerHTML = NOTE;
    foot.insertBefore(b, foot.firstChild);
  }
  var onCartPage = /^\/cart\/?$/.test(location.pathname);
  function watch() {
    if (onCartPage) {
      var main = document.querySelector('main') || document.body;
      var co = main.querySelector('form[action="/cart"] [name="checkout"][type="submit"], button[name="checkout"], [type="submit"][name="checkout"]');
      if (co && !main.querySelector('.dtg-prio')) {
        var b = document.createElement('div');
        b.className = 'dtg-prio dtg-prio--page';
        b.innerHTML = NOTE;
        co.parentNode.insertBefore(b, co);
      }
      strip().then(function (changed) { if (changed) location.reload(); }).catch(function () {});
      return;
    }
    strip().then(function (changed) { if (changed) refresh(); }).catch(function () {});
    var d = document.getElementById('mini-cart');
    if (!d) return;
    var put = function () { note(d.querySelector('.drawer__footer')); };
    put();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(put, 60); }).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* Floating cart: bottom-right bag with a live count.
   Tap opens the cart drawer (falls back to /cart). Hidden while the drawer is open. */
(function () {
  if (document.querySelector('.dtg-fcart') || /^\/cart\/?$/.test(location.pathname)) return;
  var a = document.createElement('a');
  a.href = '/cart'; a.className = 'dtg-fcart'; a.setAttribute('aria-label', 'Open cart');
  a.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2L5 8z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8" fill="none" stroke="currentColor" stroke-width="1.8"/></svg><span class="dtg-fcart__n" hidden>0</span>';
  function mount() { document.body.appendChild(a); update(); }
  var n = a.querySelector('.dtg-fcart__n');
  var upT = 0;
  function update() { clearTimeout(upT); upT = setTimeout(doUpdate, 80); }   /* bursts of events → one refresh */
  function doUpdate() {
    window.__maudCart().then(function (c) {
      var k = 0;
      c.items.forEach(function (it) { if (it.handle !== 'priority-fulfillment') k += it.quantity; });
      var prev = n.textContent;
      n.textContent = k > 99 ? '99+' : k; n.hidden = k === 0;
      document.querySelectorAll('.header__cart-count').forEach(function (h) { if (h.textContent.trim() !== String(k)) h.textContent = k; });
      a.classList.toggle('has-items', k > 0);
      if (String(k) !== prev && k > 0) { a.classList.remove('is-bump'); void a.offsetWidth; a.classList.add('is-bump'); }
    }).catch(function () {});
  }
  a.addEventListener('click', function (e) {
    var t = document.querySelector('[aria-controls="mini-cart"]');
    var d = document.getElementById('mini-cart');
    if (t) { e.preventDefault(); t.click(); }
    else if (d && 'open' in d) { e.preventDefault(); d.open = true; }
  });
  /* listening on document catches these whether they fire on <html> (and bubble up) or on document */
  ['cart:refresh', 'cart:updated', 'variant:added', 'product:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(update, 300); });
  });
  // the header count changes whenever Focal updates the cart: follow it
  function watchHeader() {
    var h = document.querySelector('.header__cart-count');
    if (h) new MutationObserver(function () { update(); }).observe(h, { childList: true, characterData: true, subtree: true });
    var d = document.getElementById('mini-cart');
    if (d) new MutationObserver(function () { a.classList.toggle('is-hidden', d.hasAttribute('open')); }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(); watchHeader(); });
  else { mount(); watchHeader(); }
})();

/* maud-rotator custom element (moved out of product-item.liquid) */

  if (!customElements.get('maud-rotator')) {
    customElements.define('maud-rotator', class extends HTMLElement {
      connectedCallback() {
        if (this._scheduled) return;
        this._scheduled = true;
        var self = this;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () { self._init(); });
        } else {
          self._init();
        }
      }
      _init() {
        if (this._inited || !this.isConnected) return;
        this._inited = true;
        this._frames = Array.prototype.slice.call(this.querySelectorAll('.maud-rotator__frame'));
        if (this._frames.length < 2) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this._i = 0;
        this._delay = 30000;
        var self = this;
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { self._start(); } else { self._stop(); }
          });
        }, { rootMargin: '50px' });
        this._io.observe(this);
      }
      _load(img) {
        if (!img || !img.dataset.src) return;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        delete img.dataset.src;
        delete img.dataset.srcset;
      }
      _start() {
        if (this._timer) return;
        var self = this;
        // Frames load one step ahead instead of all at once
        this._load(this._frames[(this._i + 1) % this._frames.length]);
        this._timer = setInterval(function () {
          if (document.hidden) return;
          var next = (self._i + 1) % self._frames.length;
          var img = self._frames[next];
          if (img.dataset.src) { self._load(img); return; }
          if (!img.complete) return; // still downloading: hold this frame
          self._frames[self._i].classList.remove('is-active');
          self._i = next;
          img.classList.add('is-active');
          self._load(self._frames[(next + 1) % self._frames.length]);
        }, this._delay);
      }
      _stop() {
        if (this._timer) { clearInterval(this._timer); this._timer = null; }
      }
      disconnectedCallback() {
        this._stop();
        if (this._io) this._io.disconnect();
      }
    });
  }

